module.exports = __webpack_public_path__ + "img/black-logo.97ca6137.png";